var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { ExpandableGrid } from "core/components/ExpandableGrid";
import { colors, fontWeight } from "core/styles/snippets";
import { Id } from "core/utils";
import React from "react";
import styled from "styled-components";
export var ProgramOverviewGrid = function (_a) {
    var title = _a.title, items = _a.items, className = _a.className, listName = _a.listName, containerRef = _a.containerRef;
    return (React.createElement(ExpandableGrid, { className: className, title: title, containerRef: containerRef, items: items.map(function (item, index) {
            switch (item.type) {
                case "content":
                    return {
                        data: item,
                        id: item.item.uuid,
                        listName: listName,
                        position: index + 1,
                    };
                case "divider":
                default:
                    return {
                        data: item,
                        id: "letter-".concat(item.letter),
                        listName: listName,
                        position: -1,
                    };
            }
        }), "data-component": Id.component.programsGrid }));
};
export var Title = styled.h3(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0 0 1.5rem 0;\n  color: ", ";\n  font-size: 1.5rem;\n  line-height: 1;\n  ", ";\n"], ["\n  margin: 0 0 1.5rem 0;\n  color: ", ";\n  font-size: 1.5rem;\n  line-height: 1;\n  ", ";\n"])), colors.black, fontWeight.extraBold);
var templateObject_1;
